(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .constant('noOfIncrements', 4)
      .constant('multipliers', [1,2,4,5])
      .constant('maxMarkerPoints', 14)
      .factory('AreaLineChartConfig', AreaLineChartConfig);

  // @ngInject
  function AreaLineChartConfig($translate, numberFilter, maxMarkerPoints, HighChartsService, AreaLineChartAxisHandle) {

    var areaLineChartOptions = {
      plotOptions: {
        series: {
          pointPlacement: 'on',
          label: {
            connectorAllowed: false
          },
          states: {
            hover: {
              enabled: true
            }
          },
          marker: {
            radius: 3,
            states: {
              hover: {
                enabled: true,
                lineWidthPlus: 0,
                radiusPlus: 0
              }
            }
          }
        },
        areaspline: {
          stacking: 'normal'
        }
      },
      tooltip: {
        shared: true,
        useHTML: true,
        padding: 0,
        hideDelay: 0,
        enabled: true,
        shape: 'rect'
      },
      chart: {
        height: 220,
        spacing: [20, 40, 5, 0],
      },
      addRemoveSeries: false
    };

    return {
      getChartOptions: getChartOptions,
      getDataOptions: getDataOptions,
      tableHeader: tableHeader,
      dateHeader: dateHeader
    };

    function getChartOptions(options) {
      var baseOptions = HighChartsService.getBaseOptions();
      return _.merge({}, baseOptions, areaLineChartOptions, setupChart(options), options.custom);
    }

    function setupChart(options) {
      var detailLevel = options.detailLevel,
          drawAreaChart = options.section.chart.chartType === 'area',
          valueType = options.section.chart.valueType,
          groupNames = options.custom.groupNames || ['none'],
          headerFormatter = options.custom.headerFormatter || defaultTooltipHeader,
          valueSuffix;

      if(valueType === 'percent') {
        valueSuffix = '%'
      }

      return {
        plotOptions: {
          series: {
            custom: {
              prependXLabelText: AreaLineChartAxisHandle.prependXLabel(detailLevel)
            }
          }
        },
        tooltip: {
          valuePrefix: options.valuePrefix || '',
          valueSuffix: valueSuffix || '',
          formatter: function () {
            return formatTooltip(this.points, groupNames, headerFormatter, numberFilter);
          }
        },
        chart: {
          type: drawAreaChart ? 'areaspline' : 'spline'
        },
        chartTitle: $translate.instant(options.section.chart.label),
        titleTooltip: $translate.instant(options.section.chart.tooltip)
      }
    }

    function getDataOptions(data, options) {
      var detailLevel = options.detailLevel,
          drawAreaChart = options.section.chart.chartType === 'area',
          valueType = options.section.chart.valueType,
          yAxisLabel = options.section.chart.yAxisLabel,
          groupNames = options.custom.groupNames || ['none'],
          visibleSeries = options.visibleSeries,
          xAxisFormatter = options.custom.xAxisFormatter;

      return {
        xAxis: AreaLineChartAxisHandle.getXAxisOptions(data, detailLevel, options.custom.multipleXAxis, xAxisFormatter),
        yAxis: AreaLineChartAxisHandle.getYAxisOptions(valueType, drawAreaChart, yAxisLabel, data),
        series: getSeriesOptions(data, options.custom.multipleXAxis, groupNames, visibleSeries)
      }
    }

    function enableMarkerPoint(value, index, xAxisIndex, series) {
      // If the current value is not null and it has both the adjacent data points as null or beyond the
      // array bounds, we should plot a single point.
      var enabled = value !== null
          && (index - 1 < 0 || series[index - 1] === null)
          && (index + 1 >= series.length || series[index + 1] === null);

      if(xAxisIndex > 0) {
        var markerInterval = Math.round(series.length / maxMarkerPoints);
        return enabled || markerInterval === 0 || ((index % markerInterval) === 0);
      }

      return enabled;
    }

    function getSeriesOptions(data, multipleXAxis, groupNames, visibleSeries) {
      return _.flatMap(data, function (range, index) {
        return _.map(range, function (series, seriesIndex) {
          return {
            name: series.label,
            className: series.color.class,
            xAxis: multipleXAxis ? index : 0,
            visible: !visibleSeries || _.includes(visibleSeries, series.label),
            index: range.length - seriesIndex,
            custom: {
              stackedTotal: series.stackedTotal,
              groupIndex: index,
              groupName: groupNames[index]
            },
            data: _.map(series.values, function (v, i) {
              return {
                y: v,
                marker: {enabled: enableMarkerPoint(v, i, index, series.values),
                  symbol: index > 0 ? 'square' : 'circle', radius: 3}
              }
            })
          };
        });
      });
    }

    function tableHeader(text, colSpan) {
      return '<th style="text-align:left" colspan="' + (colSpan || 1) + '">' + text + '</th>'
    }

    function dateHeader(selectedPoint, colSpan) {
      return _.map(selectedPoint.series.chart.options.xAxis, function (axis) {
        var date = axis.categories[selectedPoint.point.index];
        var formattedDate = (date && selectedPoint.series.options.custom.prependXLabelText(date)) || '-.-';
        return tableHeader(formattedDate, colSpan)
      });
    }

    function defaultTooltipHeader(selectedPoint) {
      return dateHeader(selectedPoint, 2).join('')
    }

    function formatTooltip(points, groupNames, headerFormatter, numberFilter) {
      var firstPoint = _.head(points);

      var header = '<tr>' + headerFormatter(firstPoint) + '</tr>';

      //TODO get all series names instead of just the points available
      var body = _(points).reverse().groupBy( function (point) {
        return point.series.name;
      }).map( function (chartValues, name) {
        var colorClass = _.head(chartValues).series.userOptions.className;
        var yValues = _(groupNames)
            .map( function (groupName) {
              var labelText = '-.-';
              var chartValue = _.find(chartValues, function (value) {
                return _.eq(value.series.options.custom.groupName, groupName) && _.eq(value.series.name, name);
              });

              if(chartValue) {
                var tooltipOptions = chartValue.series.tooltipOptions;
                var value = chartValue.series.userOptions.custom.stackedTotal ? chartValue.total : chartValue.y;
                labelText = tooltipOptions.valuePrefix + numberFilter(value) + tooltipOptions.valueSuffix;
              }
              return '<td style="text-align:right">' +  labelText + '</td>'
            })
            .join('');
        return '<tr class="' + colorClass +'"><td>' + name + '</td>' + yValues + '</tr>';
      }).join('');

      return '<table>' + header + body + '</table>';
    }
  }

})();
